"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactMlsdata = require("./react-mlsdata");

var _MarketTrends = require("./MarketTrends");

var _MarketTrends2 = _interopRequireDefault(_MarketTrends);

require("c3/c3.css");

var _lodash = require("lodash");

require("./css/main.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MTWidget = function (_Component) {
  _inherits(MTWidget, _Component);

  function MTWidget(props) {
    _classCallCheck(this, MTWidget);

    return _possibleConstructorReturn(this, (MTWidget.__proto__ || Object.getPrototypeOf(MTWidget)).call(this, props));
  }

  _createClass(MTWidget, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var filter,
          orderBy = '';

      var _props = _extends({}, this.props),
          assets = _props.assets,
          widgetselections = _props.widgetselections;
      // const Children = this.props.children;


      var _widgetselections = _extends({}, widgetselections),
          measure = _widgetselections.measure,
          period = _widgetselections.period,
          periodtype = _widgetselections.periodtype,
          geo = _widgetselections.geo,
          classtype = _widgetselections.classtype;

      var cdate = new Date();

      // window.userpreferStore = assets;

      var geofilter = [];
      geo.forEach(function (geo) {
        var g1 = geo.split(':')[0];
        var g2 = geo.split(':')[1];

        //Changes to accomodate the AreaID search
        var geoquery = g1.toLowerCase() == 'area' && !isNaN(g2) ? { and: [{ GeographyType: "" + g1 }, { AreaId: Number(g2) }] } : { and: [{ GeographyType: "" + g1 }, { GeographyName: "" + encodeURIComponent(g2) }] };
        //let geoquery={ and: [{ GeographyType: `${g1}` }, { GeographyName: `${encodeURIComponent(g2)}` }] }
        geofilter.push(geoquery);
      });

      var classtypefilter = classtype.split(',');

      if (periodtype.toLowerCase() == 'year') {
        var setperiod = cdate.getFullYear() - period + 1;
        filter = { and: [[{ Class: { 'in': classtypefilter } }], { PeriodType: periodtype }, { Period: { ge: "" + setperiod } }, { or: geofilter }] };
      } else if (periodtype.toLowerCase() == 'month') {
        var months = [];
        var monthnames = { 0: '01', 1: '02', 2: '03', 3: '04', 4: '05', 5: '06', 6: '07', 7: '08', 8: '09', 9: '10', 10: '11', 11: '12' };
        for (var i = 0; i < period; i++) {
          months.push(cdate.getFullYear() + '-' + monthnames[cdate.getMonth()]);
          cdate.setMonth(cdate.getMonth() - 1);
        }

        // const startDate = new Date('2016-04-01') ;
        // const endDate = new Date('2018-02-01') ; 

        var startDate = new Date(months[months.length - 1] + "-01");
        var endDate = new Date(months[0] + "-01");

        //    filter ={and:[[{Class : {'in':classtypefilter}}],{PeriodType : periodtype},[{Period: {'in': months}}], { or: geofilter } ]} ; 
        filter = { and: [[{ Class: { 'in': classtypefilter } }], { PeriodType: periodtype }, [{ DateValue: { ge: startDate, le: endDate } }], { or: geofilter }] };
      } else if (periodtype.toLowerCase() == 'quarter') {
        //    var thisYear = cdate.getFullYear();
        //    var quarterStart = Math.ceil((cdate.getMonth() + 1) / 3);
        //   var quarters = []; 
        //    for (var i = 0; i < period; i++) {
        // quarters.push(thisYear+'Q' + quarterStart );
        //     quarterStart--;
        //     if (quarterStart <= 0) {
        //         thisYear--;
        //         quarterStart = 4;
        //     };

        // filter ={and:[[{Class : {'in':classtypefilter}}],{PeriodType : periodtype},[{Period: {'in': quarters}}], { or: geofilter } ]} ; 
        //  filter ={and:[{GeographyType: `${geographytype}`}, { GeographyName:`${geographyvalue}`},{Class : 'Residential'},{PeriodType : periodtype},[{Period: {'in': quarters}}]] } ; 
        filter = { and: [[{ Class: { 'in': classtypefilter } }], { PeriodType: periodtype }, [{ Year: { gt: 2001 } }], { or: geofilter }] };

        // }
      }

      orderBy = ['PeriodValue' + ' desc'];

      var chart_id = 'chart_' + _.uniqueId();

      var widget = _.isEmpty(period) ? null : _react2.default.createElement(
        _reactMlsdata.MLSStats,
        { collection: "MarketTrendsYTDExpanded_KPI", filter: filter, orderBy: orderBy },
        function (_ref) {
          var loading = _ref.loading,
              error = _ref.error,
              data = _ref.data;
          return _react2.default.createElement(
            "div",
            { className: "markettrends " + (loading ? "loading" : "") },
            loading && _react2.default.createElement(
              "div",
              { className: "mtloader msg pos-absolute" },
              "Loading..."
            ),
            error && _react2.default.createElement(
              "h2",
              null,
              console.log("" + error),
              "System error in widgets. Please contact system administrator."
            ),
            data && _react2.default.createElement(
              "div",
              { className: "" + (loading ? "hidden" : "") },
              _react2.default.createElement(_MarketTrends2.default, _extends({}, _this2.props, { id: chart_id, assets: assets, widgetselections: widgetselections, data: data.value }))
            )
          );
        }
      );

      return _react2.default.createElement(
        "div",
        null,
        " ",
        widget,
        " "
      );
    }
  }]);

  return MTWidget;
}(_react.Component);

exports.default = MTWidget;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-markettrendswidget/lib/index.js
// module id = 104
// module chunks = 0